// src/screens/RequestsScreen.jsx
import { useState } from "react";
import { C, urgencyColor, statusColor, statusBg } from "../styles/tokens";
import { Icon, Badge, BloodBadge } from "../components/UI";
import NewRequestModal from "../components/NewRequestModal";
import { REQUESTS } from "../data/mockData";

export default function RequestsScreen({ showNew, setShowNew }) {
  const [reqs,   setReqs]   = useState(REQUESTS.map((r) => ({ ...r })));
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const filtered = reqs.filter((r) => {
    const matchStatus = filter === "all" || r.status === filter;
    const matchSearch =
      r.patient.toLowerCase().includes(search.toLowerCase()) ||
      r.blood.includes(search);
    return matchStatus && matchSearch;
  });

  const updateStatus = (id, status) =>
    setReqs((prev) => prev.map((r) => (r.id === id ? { ...r, status } : r)));

  const handleNewRequest = (data) => {
    setReqs((prev) => [
      {
        ...data,
        id:     `REQ00${prev.length + 1}`,
        time:   "Just now",
        status: "pending",
      },
      ...prev,
    ]);
    setShowNew(false);
  };

  return (
    <div className="fade-up" style={{ padding: 24 }}>
      {/* Toolbar */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20, alignItems: "center" }}>
        {/* Search */}
        <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}>
            <Icon name="search" size={15} color={C.muted} />
          </span>
          <input
            className="inp"
            style={{ paddingLeft: 36 }}
            placeholder="Search patient or blood group..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Status filters */}
        <div style={{ display: "flex", gap: 8 }}>
          {["all", "pending", "fulfilled", "cancelled"].map((f) => (
            <button
              key={f}
              className={`chip ${filter === f ? "active" : ""}`}
              onClick={() => setFilter(f)}
              style={{ textTransform: "capitalize" }}
            >
              {f}
            </button>
          ))}
        </div>

        {/* New request button */}
        <button
          className="btn-primary"
          style={{ width: "auto", padding: "11px 20px" }}
          onClick={() => setShowNew(true)}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 7 }}>
            <Icon name="add" size={16} color="#fff" />
            New Request
          </span>
        </button>
      </div>

      {/* Table */}
      <div className="card" style={{ overflow: "auto" }}>
        <table>
          <thead>
            <tr>
              <th>Patient</th>
              <th>Blood</th>
              <th>Units</th>
              <th>Urgency</th>
              <th>Ward</th>
              <th>Doctor</th>
              <th>Time</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ textAlign: "center", color: C.muted, padding: 40 }}>
                  No requests found
                </td>
              </tr>
            ) : (
              filtered.map((r) => (
                <tr key={r.id}>
                  <td>
                    <span style={{ fontWeight: 600, color: C.text }}>{r.patient}</span>
                    <br />
                    <span style={{ fontSize: 11, color: C.muted }}>{r.id}</span>
                  </td>
                  <td><BloodBadge group={r.blood} /></td>
                  <td style={{ fontWeight: 700 }}>{r.units}u</td>
                  <td><Badge label={r.urgency} color={urgencyColor(r.urgency)} /></td>
                  <td style={{ color: C.muted, fontSize: 12 }}>{r.ward}</td>
                  <td style={{ color: C.muted, fontSize: 12 }}>{r.doctor}</td>
                  <td style={{ color: C.muted, fontSize: 12 }}>{r.time}</td>
                  <td>
                    <span
                      className="badge"
                      style={{
                        background: statusBg(r.status),
                        color: statusColor(r.status),
                        border: `1px solid ${statusColor(r.status)}40`,
                        textTransform: "capitalize",
                      }}
                    >
                      {r.status}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 6 }}>
                      {r.status === "pending" && (
                        <>
                          <button
                            className="btn-sm"
                            style={{ background: "rgba(56,142,60,.15)", color: "#4CAF50", borderColor: "rgba(56,142,60,.3)" }}
                            onClick={() => updateStatus(r.id, "fulfilled")}
                          >✓ Fulfil</button>
                          <button
                            className="btn-sm"
                            style={{ background: "rgba(211,47,47,.12)", color: C.red, borderColor: "rgba(211,47,47,.3)" }}
                            onClick={() => updateStatus(r.id, "cancelled")}
                          >✕</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* New Request Modal */}
      {showNew && (
        <NewRequestModal
          onClose={() => setShowNew(false)}
          onSubmit={handleNewRequest}
        />
      )}
    </div>
  );
}